import styled from "@emotion/styled"
import Link from "./Link"

const UnstyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
`

export default UnstyledLink
